module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MTTEQ/tc-custom/9780830862702.jpg?1696024475389",
      "alt": "This image is the cover for the book Apostles' Creed, LifeGuide Bible Studies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Apostles' Creed, LifeGuide Bible Studies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"I believe in God the Father, Almighty, Maker of heaven and earth.\" This six-session LifeGuide® Bible Study, based on Alister McGrath's book "), _c('em', [_vm._v("I Believe,")]), _vm._v(" introduces us to the Apostles' Creed and the essential truths about God the Father, the person and work of Jesus Christ, and the Holy Spirit. Christians indeed trust in God, and the basics of our faith have remained the same for centuries. These truths are summarized in historic church documents known as creeds. The Apostles' Creed is an ideal starting point for this vital process of consolidating our grasp of the faith. For over three decades LifeGuide Bible Studies have a provided solid biblical content and raised thought-provoking questions—making for a one-of-a-kind Bible study experience for individuals and groups. This series has more than 130 titles on Old and New Testament books, character studies, and topical studies.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alister McGrath\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', [_vm._v("Alister McGrath (DPhil, DD, Oxford University) is the Andreas Idreos Professor of Science and Religion at Oxford University. He previously held the chair of theology, ministry and education and was head of the Centre for Theology, Religion  Culture at King's College, London. He is in constant demand as a speaker at conferences throughout the world and is the author of many books including "), _c('em', [_vm._v("The Dawkins Delusion?")]), _vm._v(" and "), _c('em', [_vm._v("Christianity's Dangerous Idea")]), _vm._v(". ")]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    InterVarsity Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0